// Module
var code = "<div class=\"social-login-component\" v-if=\"authSettings\"> <a v-if=\"authSettings.gitHub\" href=\"/oauth2/authorization/github\" class=\"loginBtn loginBtn--github\">Connect with Github</a> <a v-if=\"authSettings.google\" href=\"/oauth2/authorization/google\" class=\"loginBtn loginBtn--google\">Connect with Google</a> </div> ";
// Exports
module.exports = code;